'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const getUniqueArrayFromObjects = require('../../support/get-unique-array-from-objects');

function MerchantOfferCount({ coupons }) {
  const offerTypes = getUniqueArrayFromObjects(coupons, c => c.offerType);
  const offerTotals = offerTypes.map(
    type => coupons.filter(({ offerType }) => offerType === type).length
  );

  return h(
    'table.offer-count',
    h(
      'tbody.offer-count-body',
      offerTypes.map((type, index) =>
        h('tr.offer-count-row', [
          h(
            'td.offer-count-column',
            h(
              Translate,
              {
                tag: 'em',
                attrs: { class: 'offer-count-label' },
              },
              `modules.merchant.OfferCountsType.${type}`
            )
          ),
          h(
            'td.offer-count-column',
            h('span.offer-count-value', offerTotals[index])
          ),
        ])
      )
    )
  );
}

module.exports = MerchantOfferCount;
